import React from "react";
import Image from "@gqlapp/base/Image";
import opt from "@gqlapp/base/utils/opt";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";

const Control = function Control({ style, options }){
	return function Control(props){
		let value = opt(options, props?.value)

		const icon = <Image src={value?.url}
			{...{ autoSize: "85:85" }}
			style={{ objectFit: 'scale-down', width: '100%', height: '100%' }}
		/>

		let Render = Radio;
		if (!!style){
			Render = Checkbox;
		}

		return  <Box className={'btn btn-light item'}>
			<Render
				{...props}
				{...{
					checkedIcon: icon,
					icon: icon
				}}
			/>
		</Box>
	}
}

export default Control;